import { ENTITY } from '../config/routes/entity';
import { useFetchedCampaign } from './useFetchedCampaign';
import { useSelectedEntityId } from './useSelectedEntityId';

export const useSelectedCampaign = () => {
    const campaignId = useSelectedEntityId(ENTITY.CAMPAIGN);
    const { campaign, isError, isSuccess } = useFetchedCampaign(campaignId);

    return { campaign, campaignId, isError, isSuccess };
};
